import { render, staticRenderFns } from "./BaseDataModifyButton.vue?vue&type=template&id=4a600f44&"
import script from "./BaseDataModifyButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./BaseDataModifyButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
